import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Music = createReactComponent("Music", ["svg", defaultAttributes, [["path", {
  d: "M9 18V5l12-2v13",
  key: "1m5kjg"
}], ["circle", {
  cx: "6",
  cy: "18",
  r: "3",
  key: "l375l1"
}], ["circle", {
  cx: "18",
  cy: "16",
  r: "3",
  key: "4j247o"
}]]]);
export default Music;